// pages/Login.tsx (or HomeLogin.tsx)
import { useEffect, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";
import { login } from "../../services/authService";

import styles from "./Login.module.css";
import NavBar from "../../components/layout/NavBar/NavBar";
import microsoftLogo from "../../assets/icons/microsoft_logo.svg";
import findmoreLogo from "../../assets/icons/findmore_simple_icon.svg";
import illustration from "../../assets/icons/people_illustration.svg";

export default function Login() {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const [, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated) {
      const redirectUrl = sessionStorage.getItem("postLoginRedirect");
      if (redirectUrl) {
        sessionStorage.removeItem("postLoginRedirect");
        navigate(redirectUrl, { replace: true });
      } else {
        navigate("/home", { replace: true });
      }
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async () => {
    if (inProgress !== InteractionStatus.None) return;
    try {
      setError(null);
      const redirectUrl = new URLSearchParams(window.location.search).get(
        "redirect"
      );
      if (redirectUrl) {
        sessionStorage.setItem("postLoginRedirect", redirectUrl);
      }
      await login(instance);
    } catch (err: any) {
      navigate("/error?message=Erro ao iniciar sessão&errorCode=500");
    }
  };

  return (
    <div className={styles.loginContainer}>
      {/* Navbar visível apenas em desktop */}
      <div className={styles.navbarWrapper}>
        <NavBar items={[]} />
      </div>

      {/* Findmore logo para mobile */}
      <img src={findmoreLogo} alt="Logo" className={styles.mobileLogo} />

      <div className={styles.loginContent}>
        <div className={styles.loginBox}>
          <h1 className={styles.loginTitle}>Avaliação 360º</h1>
          <p className={styles.loginDescription}>
            Um espaço para te autoavaliares, reconhecer o valor dos teus colegas
            e, se for o caso, acompanhar o crescimento da tua equipa. A melhoria
            contínua começa contigo.
          </p>
          <button
            onClick={handleLogin}
            disabled={inProgress !== InteractionStatus.None}
            className={styles.loginButton}
          >
            <img
              src={microsoftLogo}
              alt="Microsoft Logo"
              className={styles.microsoftLogo}
            />
            {inProgress !== InteractionStatus.None
              ? "A REDIRECIONAR..."
              : "ENTRAR COM A MICROSOFT"}
          </button>
        </div>
      </div>

      <img
        src={illustration}
        alt="Ilustração"
        className={styles.loginIllustration}
      />
    </div>
  );
}
